import { Azure, Okta, Saml2 } from './Providers';
import type { Saml2ProviderProps, SsoProvider } from './SingleSignOn.types';

export const ssoProviders: Array<SsoProvider> = ['azure', 'okta', 'saml2'];
export const providerNameMap: Record<SsoProvider, string> = {
  azure: 'Active Directory (Azure)',
  okta: 'Okta',
  saml2: 'SAML',
};

export const getProviderComponent = (provider: SsoProvider, props?: Saml2ProviderProps) => {
  switch (provider) {
    case 'azure':
      return <Azure onLoadingChange={props?.onLoadingChange} />;
    case 'okta':
      return <Okta onLoadingChange={props?.onLoadingChange} />;
    case 'saml2':
      return <Saml2 onMetadataFileChange={props?.onMetadataFileChange} onLoadingChange={props?.onLoadingChange} />;
    default:
      return null;
  }
};
